import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../app/api";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";
import { useParams } from "react-router-dom";

import Footer from "../../common/Footer";
import _ from "lodash";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    paddingTop: TOP_PADDING,
    paddingBottom: TOP_PADDING,
    minHeight: "60vh",
    backgroundColor: theme.palette.primary.light,
  },
  thumbnail: {
    width: "100%",
  },
  titletxt: {
    fontSize: 30,
  },
  publishedbytxt: {
    fontSize: 18,
    fontWeight: "bold",
  },
}));

const Blog = (props) => {
  const classes = useStyles();
  let params = useParams();

  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.withoutAuth.get(
        `/blogs/${_.get(params, "id")}`
      );

      setData(data.message);
    } catch (error) {
      console.log(error);
    } finally {
    }
  }, [setData, params]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={2}>
            <Typography>
              {moment(_.get(data, ["updatedAt"])).format("DD MMM YYYY")}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography className={classes.titletxt}>
              {_.get(data, "title")}
            </Typography>
            <br />

            <Typography className={classes.publishedbytxt}>
              Published by - {_.get(data, "published_by")}
            </Typography>
            <br />
            <br />

            <img
              alt="thumbnail"
              src={_.get(data, "thumbnail")}
              className={classes.thumbnail}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: _.get(data, ["blogs_content_mappings", 0, "value"]),
              }}
            />
          </Grid>
        </Grid>
      </div>
      <Footer />
    </>
  );
};

export default Blog;
